import ChangePasswordPage from './change_password_page';
import EmptyPage          from '../components/empty_page';
import HelpPage           from './help_page';
import LegalPage          from './legal';
import NotificationsPage  from './notifications_page';
import ProfilePage        from './profile_page';
import renderPage         from '../components/render_page';
import Tab                from './tab';


export default {
  path:         '/:businessID/account',
  component:    renderPage(EmptyPage),
  onlyTab:      true,
  name:         'Account',
  tabComponent: {
    component: Tab,
    name:      'account'
  },
  routes: [
    {
      path:         'profile',
      name:         'Profile',
      component:    renderPage(ProfilePage),
      tabComponent: {
        component: Tab,
        name:      'account'
      },
      routes: [
        {
          name:         'ChangePassword',
          path:         'change_password',
          component:    renderPage(ChangePasswordPage),
          tabComponent: {
            component: Tab,
            name:      'account'
          }
        }
      ]
    },
    {
      path:         'notifications',
      name:         'Notifications',
      component:    renderPage(NotificationsPage),
      tabComponent: {
        component: Tab,
        name:      'account'
      }
    },
    {
      path:         'legal',
      name:         'Legal',
      component:    renderPage(LegalPage),
      tabComponent: {
        component: Tab,
        name:      'account'
      }
    },
    {
      path:         'help',
      name:         'Help',
      component:    renderPage(HelpPage),
      tabComponent: {
        component: Tab,
        name:      'account'
      }
    }
  ]
};
